import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/** Public fields only — never fetch encrypted_password to the browser. */
export type UserA1CertificateRow = {
  id: string;
  user_id: string;
  storage_bucket: string;
  storage_path: string;
  original_filename: string | null;
  uploaded_at: string;
  created_at: string;
  updated_at: string;
};

export function useUserA1Certificate() {
  return useQuery({
    queryKey: ["user-a1-certificate"],
    queryFn: async (): Promise<UserA1CertificateRow | null> => {
      const { data, error } = await supabase
        .from("user_a1_certificates")
        .select(
          "id, user_id, storage_bucket, storage_path, original_filename, uploaded_at, created_at, updated_at",
        )
        .maybeSingle();

      if (error) {
        throw new Error(error.message);
      }

      return (data as UserA1CertificateRow | null) ?? null;
    },
  });
}
